// @flow
import * as types from "../constants/action_types"

export const appendToLogger = (log: string[]) => ({
    type: types.LOG_APPEND,
    log,
})
export const setLog = (log: string[]) => ({ type: types.LOG_SET, log })
